// ログイン・新規登録の入口。2026-11-02 ひとまず全部断つ。
// false の間は /login・/start を玄関へ転送し、ログイン/無料で始めるのボタンとダイアログを出さない。
// すでにログイン中の端末はそのまま使える。再開するときはここを true にしてデプロイするだけ
export const LOGIN_OPEN = false;
